import { SelectionModel } from '@angular/cdk/collections';
import { Component, ViewEncapsulation } from '@angular/core';
import { MatLegacyCheckboxModule as MatCheckboxModule } from '@angular/material/legacy-checkbox';
import {
  MatLegacyDialogModule as MatDialogModule,
  MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';
import {
  MatLegacyTableDataSource as MatTableDataSource,
  MatLegacyTableModule as MatTableModule,
} from '@angular/material/legacy-table';
import { CuttingPointOfIssue, ICustomResponse, NgxLocalizedNumbers } from 'cloud-shared-lib';
import * as _ from 'lodash';
import { Observable } from 'rxjs';
import { filter, tap } from 'rxjs/operators';

import { AsyncPipe, JsonPipe, NgIf } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { MatToolbarModule } from '@angular/material/toolbar';
import { OrderDetailService } from '../order-detail.service';

@Component({
  templateUrl: './points-of-issue-dialog.component.html',
  styleUrls: ['./points-of-issue-dialog.component.scss'],
  standalone: true,
  imports: [
    NgIf,
    JsonPipe,
    AsyncPipe,
    NgxLocalizedNumbers,
    MatDialogModule,
    MatTableModule,
    MatToolbarModule,
    MatCheckboxModule,
    MatIconModule,
    MatButtonModule,
    MatTooltipModule,
  ],
  encapsulation: ViewEncapsulation.None,
})
export class PointsOfIssueDialogComponent {
  data$: Observable<ICustomResponse<CuttingPointOfIssue[]>>;
  // unsubscribe$: Subject<void> = new Subject();

  selection: SelectionModel<CuttingPointOfIssue> = new SelectionModel(false);

  dataSource: MatTableDataSource<CuttingPointOfIssue> = new MatTableDataSource([]);
  displayedColumns = ['selection', 'name', 'address', 'price', 'note'];

  constructor(
    public dialogRef: MatDialogRef<PointsOfIssueDialogComponent>,
    private orderDetailService: OrderDetailService
  ) {
    this.data$ = this.orderDetailService.getPointsOfIssue().pipe(
      filter(d => !_.isNil(d.result)),
      tap(d => (this.dataSource.data = d.result))
    );
  }
}
